import { RealGreen } from "./RealGreen.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  RealGreen
};
//# sourceMappingURL=index.js.map
